
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { TabDto } from '@/api/goodsModule';
import { getStoreUserNavbarList, getStoreUserNavbarTempletList } from '@/api/goodsModule';

@Component({
  name: 'tabbarMore',
})
export default class tabbarMore extends Vue {
  @Getter tabModules!: Array<TabDto>;
  @Getter companyId!: string;

  @Watch('$route')
  onRouteChange() {
    this.isShow = false;
  }

  @Watch('isShow')
  onIsShowChange(newVal) {
    this.$emit('moreIsShow', newVal)
  }

  isShow = false;
  tabs = [];

  show() {
    console.log('show');
    this.isShow = true;
    this.getNavbarList();
  }

  async getNavbarList() {
    const { data } = await getStoreUserNavbarTempletList({ storeId: this.companyId });
    let arr = []
    this.tabModules.forEach((item) => arr.push(item.route))
    this.tabs = data.filter((item) => !arr.includes(item.route));
  }

  handleTab (tab) {
    console.log('handleTab', tab)
    this.$router.push(tab.route);
    this.isShow = false;
  }

  handleMore() {
    this.$router.push('/tabbar-more');
  }

  handleEdit() {
    this.$router.push({
      path: '/tabbar-more',
      query: {
        isShake: 'shake',
      },
    });
  }
}
